import { render, staticRenderFns } from "./CoCardTicket.vue?vue&type=template&id=a29e1184&"
import script from "./CoCardTicket.vue?vue&type=script&lang=ts&"
export * from "./CoCardTicket.vue?vue&type=script&lang=ts&"
import style0 from "./CoCardTicket.vue?vue&type=style&index=0&id=a29e1184&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports